<mat-form-field appearance="outline" [floatLabel]="floatLabel" [hidden]="hidden" [ngClass]="{'full-width': fullWidth}">
    <mat-label *ngIf="!simpleSelect">
        <ng-content select="aum-form-field-label"></ng-content>
    </mat-label>

    <mat-select
        [formControl]="useIndependentControl ? control : aumFormControl"
        [compareWith]="compareWith"
        [multiple]="multiple"
        [id]="propertyOfOptionId"
        [placeholder]="placeholder"
        (selectionChange)="selectionChangeEventHandler($event)"
        #singleSelect
    >
        <ng-container *ngIf="searchEnabled">
            <mat-option>
                <ngx-mat-select-search
                    [formControl]="filterCtrl"
                    placeholderLabel="{{ 'aumico_core_search' | i18next}}"
                    noEntriesFoundLabel="{{ 'aumico_core_search_not_found' | i18next}}"
                ></ngx-mat-select-search>
            </mat-option>
            <div *ngIf="propertyOfOptionToDisplay == null && language == null">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                    {{option.name}}
                </mat-option>
            </div>

            <div *ngIf="propertyOfOptionToDisplay != null &&  language == null ">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                    {{option[propertyOfOptionToDisplay]}}
                </mat-option>
            </div>

            <div *ngIf="propertyOfOptionToDisplay != null &&  language != null && defaultLanguage!=null ">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                    {{option[propertyOfOptionToDisplay][language] != null? option[propertyOfOptionToDisplay][language] :
                    option[propertyOfOptionToDisplay][defaultLanguage]}}
                </mat-option>
            </div>
        </ng-container>

        <ng-container *ngIf="!searchEnabled">
            <mat-option *ngIf="placeholder">-- {{placeholder}} --</mat-option>
            <div *ngIf="propertyOfOptionToDisplay == null && language == null">
                <mat-option *ngFor="let option of options" [value]="option"> {{option.name}} </mat-option>
            </div>

            <div *ngIf="propertyOfOptionToDisplay != null &&  language == null ">
                <mat-option *ngFor="let option of options" [value]="option">
                    {{option[propertyOfOptionToDisplay]}}
                </mat-option>
            </div>

            <div *ngIf="propertyOfOptionToDisplay != null &&  language != null && defaultLanguage!=null ">
                <mat-option *ngFor="let option of options" [value]="option">
                    {{option[propertyOfOptionToDisplay][language] != null? option[propertyOfOptionToDisplay][language] :
                    option[propertyOfOptionToDisplay][defaultLanguage]}}
                </mat-option>
            </div>
        </ng-container>
    </mat-select>

    <mat-icon
        matSuffix
        *ngIf="aumFormControl!=null && aumFormControl.invalid && aumFormControl.touched"
        class="triangle-warning"
        svgIcon="aumico-pattern-icon-alert-triangle"
    ></mat-icon>
    <mat-error *ngIf="aumFormControl!=null && aumFormControl.invalid">
        <ng-content select="aum-form-error"></ng-content>
    </mat-error>
</mat-form-field>
